import { useEffect, useRef, useContext } from "react"
import { useDispatch } from "react-redux"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { LOADING } from "helpers/data-statuses"
import { useIntradayMode } from "./use-intraday-mode"
import { DashboardContext } from "../context/dashboard"
import { IDashboardContextValue } from "../context/types"

/**
 * Custom hook to handle intraday warning notifications
 * Shows a warning toast when in intraday mode but no intraday data is available
 */
export function useIntradayWarningNotification() {
  const dispatch = useDispatch()
  const intradayWarningShownRef = useRef(false)
  const { isIntraday } = useContext<IDashboardContextValue>(DashboardContext)
  const [{ intradayDataAvailable }, intradayBatchStatus] = useIntradayMode()

  useEffect(() => {
    // Only show warning if intraday is enabled AND no intraday data is available AND not currently loading
    if (isIntraday && !intradayDataAvailable && intradayBatchStatus !== LOADING) {
      if (!intradayWarningShownRef.current) {
        intradayWarningShownRef.current = true
        dispatch(NotificationCreators.add("warning", null, "No intraday data. Using end of previous day."))
      }
    } else if (!isIntraday || intradayDataAvailable) {
      // Reset the warning flag when:
      // - Intraday is not enabled, OR
      // - Intraday data becomes available
      intradayWarningShownRef.current = false
    }
  }, [isIntraday, intradayDataAvailable, intradayBatchStatus, dispatch])
}
